import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKayakingNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.301 5.887c4.614-3.99 9.794-5.35 12.627-5.815 1.803-.296 3.296 1.197 3 3-.464 2.833-1.825 8.013-5.815 12.627l.484.484a2.568 2.568 0 012.221.721l2.34 2.34C24.545 20.63 23.564 23 21.604 23h-.446a5 5 0 01-3.536-1.464l-.44-.44a2.965 2.965 0 01-.317-3.818L6.722 7.136a2.965 2.965 0 01-3.818-.318l-.44-.44A5 5 0 011 2.844v-.446C1 .437 3.37-.544 4.756.841l2.34 2.34c.605.606.845 1.437.721 2.222zm12.95-3.842c-2.614.429-7.329 1.675-11.532 5.26l.695.695c.738-.548 1.564-.813 2.405-.784 1.037.036 1.984.516 2.716 1.248s1.213 1.68 1.249 2.716c.03.842-.236 1.668-.784 2.406l.695.694c3.585-4.202 4.83-8.917 5.26-11.532.04-.25-.04-.435-.154-.549s-.299-.195-.55-.154zM5.822 5.18a.571.571 0 00-.14-.584l-2.34-2.34a.186.186 0 00-.102-.059.212.212 0 00-.116.015.212.212 0 00-.092.071.186.186 0 00-.031.114v.446a3 3 0 00.879 2.121l.44.44A.965.965 0 005.4 5.6zm6.036 4.263l2.7 2.7c.177-.317.238-.62.228-.893-.015-.447-.225-.933-.664-1.371-.438-.439-.924-.649-1.371-.664a1.692 1.692 0 00-.893.228zm9.86 11.526a.211.211 0 00.07-.093.21.21 0 00.016-.115.186.186 0 00-.059-.102l-2.34-2.34a.571.571 0 00-.808 0 .964.964 0 000 1.363l.44.44a3 3 0 002.12.878h.447a.186.186 0 00.114-.031z" />
        <path d="M12.739 15.981l-1.535-1.534c-.124.046-.249.09-.374.13-.955.318-1.725-.452-1.408-1.407.041-.125.085-.25.13-.375L8.02 11.261c-.195.435-.358.866-.495 1.278-.836 2.518 1.42 4.773 3.937 3.937.412-.137.843-.3 1.278-.495z" />
        <path d="M2.045 21.252c.414-2.522 1.587-6.995 4.885-11.08L5.508 8.75C1.81 13.248.52 18.186.072 20.928c-.296 1.803 1.197 3.296 3 3 2.742-.45 7.68-1.738 12.178-5.436l-1.422-1.422c-4.085 3.298-8.558 4.471-11.08 4.885-.25.04-.435-.04-.549-.154s-.195-.299-.154-.55z" />
      </g>
    </svg>
  )
);
SvgSportsKayakingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKayakingNormalSmall;
